'use client'

import { SessionProvider } from 'next-auth/react'
import { ToastProvider } from '@/components/ui/toast'
import { CommandPalette } from '@/components/CommandPalette'
import { AIProvider } from '@/context/AIContext'
import { AIManager } from '@/components/ai/AIManager'
import { LockedCorrectionDialog } from '@/components/LockedCorrectionDialog'

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider
      basePath={`${process.env.NEXT_PUBLIC_BASE_PATH || ''}/api/auth`}
      // Every refetch hands the app a new session object, and pages tied to it
      // used to reload under the user (RELI UAT 2026-10-09: "the system
      // refreshes every ~30 seconds and we lose our work"). API calls do not
      // need it: the API client reads a fresh session (and token) on every
      // request. So: once every 30 minutes, and not on every return to the tab.
      refetchInterval={30 * 60}
      refetchOnWindowFocus={false}
    >
      <AIProvider>
      {children}
      <ToastProvider />
      <CommandPalette />
      <LockedCorrectionDialog />
        <AIManager />
      </AIProvider>
    </SessionProvider>
  )
}
